import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctAddressList, FctBytes, FctValue, FctValueList } from '../../../../Fct/generics';
export var SimpleBuy = createPlugin({
    protocol: 'PARASWAP',
    type: 'ACTION',
    method: 'simpleBuy',
    supportedContracts: [{ address: '0xDEF171Fe48CF0115B1d80b88dc8eAB59176FEe57', chainId: 1 }],
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    simpleData_tuple: {
                        fromToken: new FctAddress({}),
                        toToken: new FctAddress({}),
                        fromAmount: new FctValue({}),
                        toAmount: new FctValue({}),
                        expectedAmount: new FctValue({}),
                        callees: new FctAddressList({}),
                        exchangeData: new FctBytes({}),
                        startIndexes: new FctValueList({}),
                        values: new FctValueList({}),
                        beneficiary: new FctAddress({}),
                        partner: new FctAddress({}),
                        feePercent: new FctValue({}),
                        permit: new FctBytes({}),
                        deadline: new FctValue({}),
                    },
                },
            },
            output: {},
        });
    },
    requiredApprovals: function (params) {
        var _a = params.methodParams['simpleData_tuple'], fromToken = _a.fromToken, fromAmount = _a.fromAmount;
        return [
            {
                to: fromToken.value,
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: fromAmount.value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
});
